import React, {
  useEffect,
  useState,
} from "react";
import { AppContext } from "../../store";
import { getSwithcSTAddress, getSelectedSTObj, getContactName, getContactPhone } from "../../utils/addressUtils";
import { Checkbox, message } from "antd";
import { logOperation } from "Utils/operationLogUtils";
import { ACTIVITY_NO_PERMISSION_ST_STATUS_LABEL } from "Utils/constant";

interface ShipToItem {
  id: number,
  shipTo: string,
  name: string;
  phone: string;
  addressStr: string;
  isDefault: boolean;
  addressKey: string;
  disabled?: boolean;
}
// 子组件
interface ChildComponentProps {
  showSwitchStPage: boolean;
  setShowSwitchStPage: (value: boolean) => void;
  onSTClick?: (item: Object, preSt?: string | null) => void;
  [key: string]: any;
}
const SwitchShipToPage: React.FC<ChildComponentProps> = (props) => {
  const { setShowSwitchStPage, onSTClick } = props;
  const [shipToList, setShipToList] = useState<any>([]);
  const { loginState, refreshCartData, setSelectedAddressKey } = React.useContext(AppContext);
  const allShipToBillToAddresses = loginState?.user?.allShipToBillToAddresses;


  useEffect(() => {
    if (allShipToBillToAddresses) {
      getALLShipToList();
    }
  }, [allShipToBillToAddresses]);

  const getALLShipToList  = () => {
    let tempAllShipToBillToAddresses = JSON.parse(JSON.stringify(allShipToBillToAddresses));
    let allShipToList: ShipToItem[] = [];
    if (tempAllShipToBillToAddresses && tempAllShipToBillToAddresses.length > 0) {
      tempAllShipToBillToAddresses.map((shipToBillToItem: any, shipToIndex: number) => {
        let shipItem1 = shipToBillToItem.shipTo;

        allShipToList.push({
          id: shipToIndex + 1,
          shipTo: shipItem1.accountNumber,
          name: getContactName(shipItem1, loginState.user),
          phone: getContactPhone(shipItem1, loginState.user),
          addressStr: getSwithcSTAddress(shipToBillToItem.shipTo),
          isDefault: shipToBillToItem.shipTo.isDefault,
          addressKey: shipToBillToItem.shipTo.addressKey,
          disabled: shipToBillToItem.shipTo.disabled,
        });
      });
    }        
    
    setShipToList(allShipToList)
  }

  const handleShipToChange = (item: ShipToItem) => {
    if (item.disabled) {
      message.warning(ACTIVITY_NO_PERMISSION_ST_STATUS_LABEL);
      return;
    }

    const currentAddressKey = getSelectedSTObj(loginState)?.addressKey?.toString();
    if (currentAddressKey === item.addressKey?.toString()) {
      return;
    }

    const preSelectedSTObj = getSelectedSTObj(loginState);
    let preSelectedAddressKey = localStorage.getItem('selectedAddressKey');
    if (!preSelectedAddressKey) {
      preSelectedAddressKey = preSelectedSTObj?.addressKey;
    }

    localStorage.setItem('selectedAddressKey', item.addressKey);
    setShowSwitchStPage(false);
    setSelectedAddressKey(item.addressKey?.toString());
    refreshCartData();

    const opTargetId =
      (preSelectedSTObj?.accountNumber || preSelectedSTObj?.addressKey) +
      ',' +
      (item?.shipTo || item?.addressKey);

    logOperation({
      opUser: props.userId,
      opTarget: "Exchange_ST",
      opTargetId: opTargetId,
      opContent: props.page,
    });

    onSTClick && onSTClick(item, preSelectedAddressKey);
  };

  const userInfo = loginState?.user?.user
  const lastName = userInfo?.lastName || '';
  const firstName = userInfo?.firstName || '';
  return (
    <div
      className="switch-shipto-container"
    >
      {
        shipToList?.map((item: any, index: any) => {
          const selectedSTObj = getSelectedSTObj(loginState);
          return <div
            className="switch-shipto-item"
            key={index}
            style={{
              opacity: item.disabled ? 0.45 : 1,
              cursor: item.disabled ? "not-allowed" : "pointer",
            }}
            onClick={() => {
              handleShipToChange(item);
            }}
          >
            <div className="shipto-basic-info" style={{display: "flex"}}
            >
              <div style={{width: item.isDefault ? '87%' : '100%'}}>
                <span
                  style={{ display: "inline-flex", cursor: item.disabled ? "not-allowed" : "pointer" }}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleShipToChange(item);
                  }}
                >
                  <Checkbox
                    disabled={item.disabled}
                    checked={ (item.addressKey.toString() === selectedSTObj?.addressKey.toString()) ? true : false}
                    style={{ pointerEvents: "none" }}
                  >

                  </Checkbox>
                </span>
                <label 
                  className="nick-name"
                    >
                      {item.name ? item.name : `${lastName}${firstName}`}
                      {/* {`${lastName}${firstName}`} */}
                </label>
                <span style={{ color: "#aeaeae" }}>{item.phone}</span>
              </div>
              {item.isDefault && <div
                className="default-info"
              >
                默认
              </div>}
            </div>
            <div className="shipto-basic-address">{`${item.addressStr}`}</div>
          </div>
          })
      }
    </div>
  );
};

export default SwitchShipToPage;
